var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3831_11936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17C1.5 8.16344 8.66344 1 17.5 1C26.3366 1 33.5 8.16344 33.5 17C33.5 25.8366 26.3366 33 17.5 33C8.66344 33 1.5 25.8366 1.5 17Z",
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17C1.5 8.16344 8.66344 1 17.5 1C26.3366 1 33.5 8.16344 33.5 17C33.5 25.8366 26.3366 33 17.5 33C8.66344 33 1.5 25.8366 1.5 17Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3831_11936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4974 12.8333V9.5H9.16406V24.5H25.8307V12.8333H17.4974ZM12.4974 22.8333H10.8307V21.1667H12.4974V22.8333ZM12.4974 19.5H10.8307V17.8333H12.4974V19.5ZM12.4974 16.1667H10.8307V14.5H12.4974V16.1667ZM12.4974 12.8333H10.8307V11.1667H12.4974V12.8333ZM15.8307 22.8333H14.1641V21.1667H15.8307V22.8333ZM15.8307 19.5H14.1641V17.8333H15.8307V19.5ZM15.8307 16.1667H14.1641V14.5H15.8307V16.1667ZM15.8307 12.8333H14.1641V11.1667H15.8307V12.8333ZM24.1641 22.8333H17.4974V21.1667H19.1641V19.5H17.4974V17.8333H19.1641V16.1667H17.4974V14.5H24.1641V22.8333ZM22.4974 16.1667H20.8307V17.8333H22.4974V16.1667ZM22.4974 19.5H20.8307V21.1667H22.4974V19.5Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3831_11936",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3831_11936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3831_11936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3831_11936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdIcon);
export default __webpack_public_path__ + "static/media/profileAdIcon.47ec3570ff434a8bde8dd952e615dc3b.svg";
export { ForwardRef as ReactComponent };